export default __webpack_public_path__ + "static/media/stop.027e1f56.svg";